/**
 * Super Admin table presentation — reuse Contacts / Reports table language.
 */
import {
  contactsTableBodyCellClass,
  contactsTableBodyRowClass,
  contactsTableClass,
  contactsTableHeaderCellClass,
  contactsTableHeaderIconWrapClass,
  contactsTableHeaderLabelClass,
  contactsTableHeadRowClass,
  contactsTableShellClass,
} from "../contacts/contacts-table-presentation.js";

export {
  contactsTableBodyCellClass,
  contactsTableBodyRowClass,
  contactsTableClass,
  contactsTableHeaderCellClass,
  contactsTableHeaderIconWrapClass,
  contactsTableHeaderLabelClass,
  contactsTableHeadRowClass,
  contactsTableShellClass,
};

/** Outer shell for Super Admin tables (Contacts visual language). */
export const superAdminTableWorkspaceClass = `${contactsTableShellClass} flex min-h-0 flex-col overflow-hidden`;

export const superAdminTableScrollClass =
  "min-h-0 overflow-x-auto overscroll-contain [scrollbar-gutter:stable]";

export const superAdminTableClass = `${contactsTableClass} min-w-0`;

export const superAdminTableHeadRowClass = `${contactsTableHeadRowClass} sticky top-0 z-[1]`;

export const superAdminTableHeaderCellClass = contactsTableHeaderCellClass;

export const superAdminTableBodyRowClass = contactsTableBodyRowClass;

export const superAdminTableBodyCellClass = contactsTableBodyCellClass;

/** Allowed page sizes for Super Admin cursor lists (audit logs max 50). */
export const SUPER_ADMIN_TABLE_PAGE_SIZES = [25, 50] as const;

export type SuperAdminTablePageSize = (typeof SUPER_ADMIN_TABLE_PAGE_SIZES)[number];

export const SUPER_ADMIN_TABLE_DEFAULT_PAGE_SIZE: SuperAdminTablePageSize = 25;
